import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BaseAuthComponent } from '@layouts/default/layouts/guest/pages/home/components/base-auth.component';
import { Event, NavigationEnd } from '@angular/router';
import { Config } from '@shared/config';
import { ProjectsService } from '@layouts/default/layouts/guest/pages/projects/projects.service';
import { HeaderService } from '@shared/services/header.service';
import { MenuService } from '@shared/services/menu.service';
import { ItemMenu } from '@shared/models/item-menu.model';
import { Menu } from '@shared/interfaces/menu/menu.interface';

@Component({
  selector: 'app-header-mobile',
  templateUrl: './header-mobile.component.html',
  styleUrls: ['./header-mobile.component.scss'],
})
export class HeaderMobileComponent extends BaseAuthComponent implements Menu {
  @Input() eventCategory;
  ukraineUrl: boolean = false;

  isSidebarAccountMenuOpen: boolean = false;
  notificationOpen: boolean = false;
  @Output() openNotificationsEmitter: EventEmitter<any> = new EventEmitter();
  @Output() closeNotificationsEmitter: EventEmitter<any> = new EventEmitter();
  @Output() openMobileMenuEmitter: EventEmitter<any> = new EventEmitter();
  @Input() notificationsUnseen: number = 0;
  @Input() cartListLength: number = 0;
  @ViewChild('sidebar') sidebar: ElementRef;
  menuItems: ItemMenu[];
  facebookLink: string;
  instagramLink: string;
  headerLink: string;
  logoSrc: string;

  @HostListener('window:resize', ['$event']) onResize(event) {
    if (event.target.innerWidth >= 768) {
      this.closeMobileMenu();
      this.closeNotificationsMobile();
    }
  }

  constructor(
    public projects: ProjectsService,
    public header: HeaderService,
    public menuService: MenuService
  ) {
    super();
    this.onRouteChange();
  }

  isActive(page: string) {
    return this.router.url.search(page) > 0;
  }

  isWelcome() {
    return this.router.url === '/';
  }

  openNotifications() {
    document.body.parentElement.style.cssText = Config.MOBILE_MENU_OPEN_HTML_CLASSES;
    document.body.classList.remove('mobile-menu-open');
    document.getElementsByTagName('html')[0].classList.remove('mobile-menu-open');
    document.body.classList.add('mobile-notifications-open');
    this.notificationOpen = true;
  }

  closeNotificationsMobile() {
    document.body.parentElement.removeAttribute('style');
    document.body.classList.remove('mobile-notifications-open');
    this.notificationOpen = false;
  }

  setAutoFocus(value) {
    this.storage.put('autofocus', value);
  }

  removeAutofocus() {
    this.storage.delete('autofocus');
  }

  onMobileMenuClick() {
    this.openMobileMenuEmitter.emit();
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    if (iOSSafari) {
      document.getElementsByTagName('html')[0].classList.add('mobile-menu-open');
    } else {
      this.sidebar.nativeElement.style.top = document.documentElement.scrollTop + 'px';
    }
    document.body.classList.add('mobile-menu-open');
    document.body.parentElement.style.cssText = Config.MOBILE_MENU_OPEN_BODY_CLASSES;
  }

  closeMobileMenu() {
    document.body.classList.remove('mobile-menu-open');
    document.getElementsByTagName('html')[0].classList.remove('mobile-menu-open');
    document.body.parentElement.removeAttribute('style');
  }

  onSidebarAccountMenuClick() {
    this.isSidebarAccountMenuOpen = !this.isSidebarAccountMenuOpen;
  }

  onRouteChange() {
    const subMobileRouterHeader = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.ukraineUrl = this.menuService.isUkraineUrl();
        this.menuItems = this.menuService.loadMenu();
        this.facebookLink = this.menuService.facebookLink();
        this.instagramLink = this.menuService.instagramLink();
        this.headerLink = this.menuService.getHeaderLink();
        this.logoSrc = this.menuService.getLogo();
        this.closeMobileMenu();
      }
    });
    this.someSubscriptions.add(subMobileRouterHeader);
  }
}
